import get from 'lodash/get'

export function isProductDiscounted (productPriceData) {
  return !!get(productPriceData, 'discount')
}
